import moment from "moment";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import API from "../../common/API";
import Settings from "../../common/Settings";
import { buildRecordPath } from "../../common/recordIdentifier";

const RecordJudicialRecords = (props: any) => {
    const { id } = props;
    const [records, setRecords] = useState<any>([]);
    const { t } = useTranslation();

    const bindRecords = async () => {
        try {
            const response = await API.getAction(`employee/getJudicialRecords?id=${id}`);
            if (response.status === 200) {
                setRecords(response.data.response || []);
            } else {
                console.error("Error fetching employment records:", response.statusText);
            }
        } catch (error) {
            console.error("Error fetching employment records:", error);
        }
    }

    useEffect(() => {
        if (id) {
            bindRecords();
        }
    }
        , [id]);
    if (records.length === 0) {
        return null;
    }

    return (<>
        <Card className="my-4" >
            <Card.Header className="display-4">{t("Antecedentes Judiciales")}</Card.Header>
            <Card.Body className="p-0">
                <Row>
                    <Col xs={12}>
                        <div className="table-responsive">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        {/* <th>{t("Tipo")}</th>
                                        <th>{t("No.")}</th> */}
                                        <th>Img</th>
                                        {/* <th>{t("Fecha")}</th> */}
                                        <th>{t("Descripción")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {records && records.map((item, index) => {
                                        return <tr key={index}>
                                            {/* <td>{item.type}</td>
                                            <td>{item.number}</td> */}
                                            <td>
                                                {item.fotoCaso &&
                                                    <a href={`${Settings.BasePath}${(item.fotoCaso.includes("/")) ? "" : "files/"}${item.fotoCaso}`} target="_blank" rel="noopener noreferrer">
                                                        <img
                                                            src={`${Settings.BasePath}${(item.fotoCaso.includes("/")) ? "" : "files/"}${item.fotoCaso}`}
                                                            alt="Foto del caso"
                                                            className="img-thumbnail "
                                                            style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                                        />
                                                    </a>}
                                            </td>
                                            {/* <td>{item.date}</td> */}
                                            <td className="text-wrap">
                                                {item.tipoFicha === "Blanca" &&
                                                    <div className="mb-2">
                                                        <span className="badge bg-secondary">{t("Ficha Blanca / Persona de Interés")}</span>
                                                    </div>}
                                                {item.agraviado &&
                                                    <div className="mb-2 p-2 border rounded bg-light">
                                                        <small className="text-muted d-block">{t("Víctima")}</small>
                                                        {item.agraviadoCedula ? (
                                                            <a
                                                                href={buildRecordPath(item.agraviadoCedula)}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="fw-bold text-decoration-none"
                                                            >
                                                                {item.agraviado}
                                                            </a>
                                                        ) : (
                                                            <span className="badge bg-warning text-dark">{item.agraviado}</span>
                                                        )}
                                                    </div>}
                                                <div dangerouslySetInnerHTML={{ __html: item.description }}></div>
                                                <p className="mt-2">
                                                    {/* Check to add all the links that it has */}
                                                    {item.enlace1 && <a href={item.enlace1} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-sm text-decoration-none">
                                                        <i className="fas fa-link"></i> {t("Enlace 1")}
                                                    </a>}
                                                    {item.enlace2 && <a href={item.enlace2} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-sm text-decoration-none ms-2">
                                                        <i className="fas fa-link"></i> {t("Enlace 2")}
                                                    </a>}
                                                    {item.enlace3 && <a href={item.enlace3} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-sm text-decoration-none ms-2">
                                                        <i className="fas fa-link"></i> {t("Enlace 3")}
                                                    </a>}
                                                    {item.enlace4 && <a href={item.enlace4} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-sm text-decoration-none ms-2">
                                                        <i className="fas fa-link"></i> {t("Enlace 4")}
                                                    </a>}
                                                    {item.enlace5 && <a href={item.enlace5} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-sm text-decoration-none ms-2">
                                                        <i className="fas fa-link"></i> {t("Enlace 5")}
                                                    </a>}
                                                </p>
                                            </td>

                                        </tr>

                                    }
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    </>
    );
};

export default RecordJudicialRecords;
